import { z } from "zod";

import { zFieldMeta, zFilterValueType } from "./ZFilterApiTypes";

export type ZFilterMetadataLoadContext =
  | { kind: "catalog"; catalogId: string }
  | { kind: "class"; classId: string };

// Описание доступного поля
export const zFilterableField = z.object({
  fieldMeta: zFieldMeta,
  tag: z.string(),
  label: z.string(),
  type: zFilterValueType,
});
export type ZFilterableField = z.infer<typeof zFilterableField>;

// Описание оператора
export const zOperatorDefinition = z.object({
  code: z.string(),
  label: z.string(),
  requiresValue: z.boolean(),
});
export type ZOperatorDefinition = z.infer<typeof zOperatorDefinition>;

// Маппинг операторов
export const zOperatorsMapping = z.object({
  TEXT: z.array(zOperatorDefinition),
  NUMBER: z.array(zOperatorDefinition),
  DATETIME: z.array(zOperatorDefinition),
  BOOLEAN: z.array(zOperatorDefinition),
});
export type ZOperatorsMapping = z.infer<typeof zOperatorsMapping>;

// Ответ от API
export const zFilterMetadataResponse = z.object({
  fields: z.array(zFilterableField),
  operatorsMapping: zOperatorsMapping,
});
export type ZFilterMetadataResponse = z.infer<typeof zFilterMetadataResponse>;
